<template>
  <div class="recommenVideo">
    <el-carousel height="175px" indicator-position="none">
      <el-carousel-item v-for="(item, key) in advertisementsList" :key="key">
        <img
          @click="gotoURL(item.link)"
          :src="item.url"
          style="width: 100%; border-radius: 5px"
        />
      </el-carousel-item>
    </el-carousel>
    <div
      v-for="(item, key) in contentInfoList"
      :key="key"
      style="padding: 0.5rem 0rem"
    >
      <div class="recommenVideoTitle" style>
        <span>{{ item.categoryName }}</span>
        <span
          @click="changVideoList"
          style="font-size: 16px; color: #999999; display: flex"
        >
          换一换
          <div style="font-size: 17px; color: #999999; margin-left: 10px">
            <svg-icon icon-class="u179" />
          </div>
        </span>
      </div>
      <div class="recommenVideoContent" style="display: flex">
        <div
          style="width: 49%; margin-right: 2%"
          @click="handleDetail(item.videos[1].id, InfoObject.code)"
        >
          <div style="position: relative">
            <img
              :src="getImageURL(item.videos[1].cover)"
              :style="{
                width: '100%',
                height: `${((screenWidth - 32) * 0.49 * 9) / 16}px`,
              }"
            />
            <div
              style="
                position: absolute;
                bottom: 5px;
                left: 5px;
                display: flex;
                align-items: center;
              "
            >
              <div style="font-size: 17px; color: #000">
                <svg-icon icon-class="u181" />
              </div>
              <span style="color: #fff; margin-left: 4px">{{
                item.videos[1].playNumber | formatReadNumber
              }}</span>
            </div>
          </div>
          <div class="overTwo">
            {{ item.videos[1].title }}
          </div>
        </div>
        <div
          style="width: 49%"
          @click="handleDetail(item.videos[2].id, InfoObject.code)"
        >
          <div style="position: relative">
            <img
              :src="getImageURL(item.videos[2].cover)"
              :style="{
                width: '100%',
                height: `${((screenWidth - 32) * 0.49 * 9) / 16}px`,
              }"
            />
            <div
              style="
                position: absolute;
                bottom: 5px;
                left: 5px;
                display: flex;
                align-items: center;
              "
            >
              <div style="font-size: 17px; color: #000">
                <svg-icon icon-class="u181" />
              </div>
              <span style="color: #fff; margin-left: 4px">{{
                item.videos[2].playNumber | formatReadNumber
              }}</span>
            </div>
          </div>
          <div class="overTwo">
            {{ item.videos[2].title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import { getImageURL } from "@/utils/zgly-utils.js";
export default {
  components: {},
  created() {},
  mounted() {
    this.getInfoClass();
    this.getContentInfo(3);
    this.screenWidth = document.body.clientWidth;
  },
  filters: {
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      screenWidth: 0,
      contentInfoList: [],
      InfoObject: {},
      advertisementsList: [],
    };
  },
  computed: {},
  methods: {
    getImageURL(cover) {
      return getImageURL(cover);
    },
    getInfoClass() {
      request.getDicts().then((res) => {
        this.InfoObject = res.data.filter((item) => item.value === "视频")[0];
      });
      request
        .getPosters({
          type: "VIDEO_CAROUSEL",
        })
        .then((res) => {
          if (res.code == 0) {
            this.advertisementsList = res.data;
          }
        });
    },
    getContentInfo(val) {
      request.getResourceVideosRecently({ size: val }).then((res) => {
        this.contentInfoList = res.data;
      });
    },
    changVideoList() {
      this.getContentInfo(3);
    },
    handleDetail(id, type) {
      this.$router.push({ path: `/video/player/${id}?type=VIDEO` });
    },
    gotoURL(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="less">
.recommenVideo {
  margin: 0rem 16px;
  .recommenVideoTitle {
    display: flex;
    justify-content: space-between;
    margin: 0.5rem 0rem;
    font-size: 1.2rem;
  }
  .recommenVideoContent {
    font-size: 0.9rem;
  }
  .overTwo {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>